<template>
    <Navbar :title="'科服券'"></Navbar>
    <div class="box">
        <van-image
            width="100%"
            height="100%"
            fit="contain"
            :src="require('@/assets/images/coupon/coupon_detail_1@2x.svg')"
            style="margin-top: -44px;"
        />
    </div>
    <div class="box flex" style="margin: 0 10px;">
        <div class="flex-item" @click="goCertificate">
            <van-image
                width="100%"
                height="100%"
                fit="contain"
                :src="require('@/assets/images/coupon/coupon_detail_2@2x.svg')"
            />
        </div>
        <div class="flex-item" @click="goShare">
            <van-image
                width="100%"
                height="100%"
                fit="contain"
                :src="require('@/assets/images/coupon/coupon_detail_3@2x.svg')"
            />
        </div>
    </div>
    <div class="box" @click="goVip" style="margin: 0 3px 0 10px;">
        <van-image
            width="100%"
            height="100%"
            fit="contain"
            :src="require('@/assets/images/coupon/coupon_detail_4@2x.svg')"
        />
    </div>
    <div class="box" style="margin: 0 10px;">
        <van-image
            width="100%"
            height="100%"
            fit="contain"
            :src="require('@/assets/images/coupon/coupon_detail_5@2x.svg')"
        />
    </div>
</template>
<script>
import Navbar from '@/components/Navbar'
import { queryUserById } from '@/api/home'
import { clickUrl,goCodeFirm } from '@/utils'
import store from '@/store'

export default {
name:'Coupon',
  data() {

    return {
      userInfo: {}
    }
  },
  components: { Navbar },
  computed: {},
 
  mounted() {
      this.getUser()
  },
  watch: {},
  methods: {
    async getUser(){
      try {
        let res = await queryUserById()
        this.userInfo = res.result || {}
      } catch {}
    },
      goVip() {
        if (goCodeFirm(this.userInfo)) {
            return false
        }
        clickUrl('/vip')
      },
      goCertificate() {
        if (goCodeFirm(this.userInfo)) {
            return false
        }
            if(!this.userInfo.certification_flag){
                // clickUrl('/coupon/company_certificate')
                 clickUrl('/purchase', {source:'certificateAgain'})
                return false 
            }
            this.$dialog.confirm({
                title: '温馨提示',
                message: '您已认证，是否重新认证企业信息?',
                confirmButtonText: '确认'
            }).then(() => {
                // clickUrl('/coupon/company_certificate')
                clickUrl('/purchase', { source: 'certificateAgain' })
            }).catch(() => {
                
            })
      },
      goShare(){
           clickUrl('/coupon/share')
      },
  }
}
</script>
<style lang="scss" scoped>

</style>
